class createMappingController {
  $onInit() {
    if (Object.prototype.toString.call(this.targetMap) !== '[object Map]') {
      throw new Error('"targetMap" passed to "createMappingDirective" is not a map object');
    }

    this.targetMap.set(this.key, this.value);
  }
}

export default function createMapping() {
  return {
    restrict: 'A',
    controller: createMappingController,
    bindToController: true,
    scope: {
      targetMap: '<',
      key: '<',
      value: '<',
    },
  };
}
